module.exports = __webpack_public_path__ + "static/media/lkr.7fe11047.jpg";